export default __webpack_public_path__ + "static/media/warning--junction-with-side-roads--g1.266339ad.png";